/** Phase 234 — Tiny haptic-feedback helper.
 * Uses navigator.vibrate (Android Chrome / WebView). Silently no-ops on
 * desktop / iOS Safari (no public Web haptic API there). Patterns are
 * short and respectful — gentle nudges, not rumbles. */

const PATTERNS = {
  light: 8,
  medium: 14,
  heavy: 22,
  success: [10, 20, 10],
  error: [30, 40, 30],
  warning: [16, 30, 16],
};

let enabled = true;
try {
  if (typeof window !== "undefined") {
    enabled = window.localStorage.getItem("pwa_haptics_off") !== "1";
  }
} catch { /* ignore */ }

export function setHapticsEnabled(on) {
  enabled = !!on;
  try { window.localStorage.setItem("pwa_haptics_off", on ? "0" : "1"); } catch { /* ignore */ }
}

export function haptic(kind = "light") {
  if (!enabled) return;
  if (typeof navigator === "undefined" || !navigator.vibrate) return;
  // Skip if the user/page is hidden — don't buzz a backgrounded tab
  if (typeof document !== "undefined" && document.hidden) return;
  const pattern = PATTERNS[kind] || PATTERNS.light;
  try { navigator.vibrate(pattern); } catch { /* ignore */ }
}
